export enum ModuleType {
  CCM = 'ccm',
  RPM = 'rpm',
  ADMIN = 'admin',
}
